<script setup>
import { usePage } from "@inertiajs/vue3";

const appBaseUrl = usePage().props.appBaseUrl;
</script>

<template>
    <div class="bg-danger min-vh-100 d-flex flex-lg-row">
        <div class="background-overlay"></div>
        <div id="left-container" class="d-lg-flex d-none mx-3 mx-lg-0">
            <div class="ms-5 d-flex align-items-center">
                <div class="row">
                    <div class="col-12 text-white">
                        <h1 class="auth-title-large">Meteraiku</h1>
                        <h1 class="auth-title-small">EVENT PANEL</h1>
                    </div>
                </div>
            </div>
        </div>

        <div id="right-container" class="d-flex">
            <div class="my-auto mx-1 row justify-content-center flex-grow-1">
                <div class="col-12 col-md-8">
                    <div class="content-box px-md-5 px-3 py-md-4 py-2 mb-2">
                        <div class="text-center mb-md-5 mb-3 mt-3">
                            <div class="mx-auto d-flex justify-content-center">
                                <img
                                    id="logo"
                                    :src="
                                        appBaseUrl +
                                        '/assets/images/meteraiku-logo.jpg'
                                    "
                                    class="my-auto"
                                    alt="logo"
                                />
                            </div>
                            <div id="logo-title" class="text-center mt-2">
                                <span class="d-block d-lg-none">
                                    METERAIKU<br />
                                    EVENT
                                </span>
                            </div>
                        </div>

                        <slot />
                    </div>
                    <div class="text-center text-white">
                        Powered By OMNI IT Consulting
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
#left-container {
    flex-grow: 2;
    margin-top: -50px;
    z-index: 5;
}

@media only screen and (min-width: 1000px) {
    #left-container {
        min-width: 562px;
    }
}

.background-image {
    background-image: url("/assets/images/germplasm-login2.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
}

.background-overlay {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 1;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
}

#logo {
    width: 115px;
}

.circle-wrapper {
    width: 110px;
    height: 110px;
    background: white;
    border-radius: 90px;
}

#left-container #logo-title {
    font-weight: bold;
}

#right-container {
    flex-grow: 3;
    min-height: 200px;
    z-index: 5;
}

#right-container h3 {
    margin-left: 100px;
    font-size: 3rem;
    line-height: 3.8rem;
    color: #fff;
    z-index: 100;
}

.auth-title-small {
    font-size: 45px;
}

.auth-title-large {
    font-size: 90px;
    line-height: 80px;
    font-weight: bold;
}

@media (max-width: 576px) {
    .content-box {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 20px;
    }
}

@media (min-width: 576px) {
    .content-box {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 50px;
    }
}
</style>
